import { render, staticRenderFns } from "./AppNavi.vue?vue&type=template&id=65efe909&scoped=true"
import script from "./AppNavi.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavi.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AppNavi.vue?vue&type=style&index=0&id=65efe909&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efe909",
  null
  
)

export default component.exports